import { render, staticRenderFns } from "./ComplieLeftMenuShareTIps.vue?vue&type=template&id=3db7a5eb&scoped=true"
import script from "./ComplieLeftMenuShareTIps.vue?vue&type=script&lang=js"
export * from "./ComplieLeftMenuShareTIps.vue?vue&type=script&lang=js"
import style0 from "./ComplieLeftMenuShareTIps.vue?vue&type=style&index=0&id=3db7a5eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db7a5eb",
  null
  
)

export default component.exports